import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-city",
  "use": "icon-city-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-city\"><path fill=\"#333333\" d=\"M824.888889 568.888889v-199.111111c0-54.044444-36.977778-96.711111-85.333333-110.933334V170.666667l-28.444445-28.444445-28.444444 28.444445v88.177777c-48.355556 11.377778-85.333333 56.888889-85.333334 110.933334v256h-113.777777v85.333333h-113.777778v-199.111111l-227.555556-170.666667v227.555556H85.333333v369.777778h853.333334V568.888889h-113.777778z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/city.svg
// module id = WTnP
// module chunks = 5